import { fireFilterBarChipGA4Event } from '@/components/TypeAhead/FilterBar/ga4'
import { Carousel, InputChip } from '@pcln/horizon'
import { type SetStateAction } from 'react'
import type { FilterCategoryHotel, SelectedTopFilters } from '../types'

export default function HorizonSelectedFilterChipBar({
  selectedFilterChipData,
  setSelectedFilterChipData,
}: {
  selectedFilterChipData: SelectedTopFilters
  setSelectedFilterChipData: (value: SetStateAction<SelectedTopFilters>) => void
}) {
  const allFilters = Array.from([
    ...selectedFilterChipData.amenities,
    ...selectedFilterChipData.neighborhoods,
    ...selectedFilterChipData.hotelStarLevel,
    ...selectedFilterChipData.guestRating,
    ...selectedFilterChipData.propertyTypes,
  ])
  return (
    <Carousel
      carouselId='hotel-form-selected-filters'
      dragFree
      slotClassNames={{
        containerClass: 'gap-2',
      }}
      slideWidth='auto'
      slides={allFilters.map((item) => {
        const filterStringValues = item.split('_')
        const [filterType, code, name] = filterStringValues as [FilterCategoryHotel, string, string]
        return {
          childrenNodes: (
            <InputChip
              label={name}
              onCloseButtonClick={() => {
                setSelectedFilterChipData((prev: SelectedTopFilters) => {
                  const newFilteredSet = new Set(prev[filterType])
                  const gaFilterItem = filterType === 'neighborhoods' ? code : name
                  fireFilterBarChipGA4Event(filterType, gaFilterItem, false)
                  newFilteredSet.delete(`${filterType}_${code}_${name}`)
                  return {
                    ...prev,
                    [filterType]: newFilteredSet,
                  }
                })
              }}
            />
          ),
          id: item,
        }
      })}
      type='content'
    />
  )
}
